import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import Routing from '../Routing'
import Login from '../pages/Login'
import isLoggedIn from '../HOC/index'

class App extends Component {
    render() {
        return (
            <div className="App">
                <Switch>
                    <Route path="/login" component={isLoggedIn(Login, "/login")} />
                    <Route path="*" component={isLoggedIn(Routing)} />
                </Switch>
            </div>
        )
    }
}

export default App